<template>
  <router-view />
</template>

<script>
export default {
  name: 'Admin.Management'
}
</script>

<style scoped>

</style>
